<script setup lang="ts">
import './_index.scss'
import type { Props } from './types'

const { t } = useI18n()

defineProps<Props>()

</script>

<script lang="ts">
export default {
  name: 'PdAmenitiesList'
}
</script>

<template>
  <div
    class="pd-amenities mt-48">
    <div class="flex flex-col-reverse lg:flex-col justify-between gap-24 lg:gap-0">
      <span
        v-sanitize="t('amenities.subTitle')"
        class="display-6 lg:display-5 text-pine-600 mx-0" />

      <img
        class="max-w-48 lg:max-w-176"
        src="https://assets.lahaus.com/static/svgs/icons/heart_2.svg"></img>
    </div>

    <ul class="pd-amenities__list-container flex-1">
      <li
        v-for="(amenitie, index) in amenitiesList"
        :key="index">
        {{ amenitie }}
        <hr class="my-16">
      </li>
    </ul>
  </div>
</template>

<i18n src="./i18n.json" lang="json" />
